<template>
  <shared-field-form-preview :form="form" :field-data="field"></shared-field-form-preview>
</template>

<script>
import SharedFieldFormPreview from "../SharedFieldFormPreview";

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: false,
    },
  },
  components: {SharedFieldFormPreview},

  emits: ['input'],

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// SharedFormSummaryRender.vue?b1842cf0